import type { Project } from '@/payload-types'

/**
 * Link target for project cards. The optional `link` field overrides the
 * canonical detail URL `/projects/{slug}` (e.g. external Matterport URLs).
 */
export function getProjectHref(project: Pick<Project, 'slug' | 'link'>): string | null {
  const override = typeof project.link === 'string' ? project.link.trim() : ''
  if (override.length > 0) return override
  const slug = typeof project.slug === 'string' ? project.slug.trim() : ''
  if (!slug) return null
  return `/project/${encodeURIComponent(slug)}`
}
